

export const regex = /^(\d{1,2})[Hh]?(\d{0,2})$/